import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ClipsService} from './clips.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  exports: []
})
export class ClipsModule {
}
